import React, { useState, useEffect } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import AceEditor from 'react-ace';

// Importer la configuration d'Ace
import './AceConfig';

const JSONEditor = ({ value, onChange, readOnly = false, height = '300px' }) => {
  const [editorValue, setEditorValue] = useState('');
  const [error, setError] = useState(null);

  // Convertir l'objet en JSON formaté au chargement
  useEffect(() => {
    try {
      const jsonString = JSON.stringify(value || {}, null, 2);
      setEditorValue(jsonString);
      setError(null);
    } catch (err) {
      setError(`Erreur lors du parsing JSON: ${err.message}`);
      setEditorValue('{}');
    }
  }, [value]);

  // Mettre à jour la valeur lorsque l'utilisateur modifie le contenu
  const handleChange = (newValue) => {
    setEditorValue(newValue);
    try {
      const parsedValue = JSON.parse(newValue);
      onChange(parsedValue);
      setError(null);
    } catch (err) {
      setError(`Erreur de syntaxe JSON: ${err.message}`);
    }
  };

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <AceEditor
        mode="json"
        theme="github"
        value={editorValue}
        onChange={handleChange}
        name="json-editor"
        width="100%"
        height={height}
        fontSize={14}
        showPrintMargin={false}
        showGutter={true}
        highlightActiveLine={true}
        readOnly={readOnly}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
        }}
      />
    </Box>
  );
};

export default JSONEditor; 